import { Spin } from "antd";
import SingleStrikeTable from "./SingleStrikeTable";

import "./gridStyles.css";
import useStrikeTable from "./hooks/useStrikeTable";

function StickyStrikeTable({ dateTime }) {
  const { dark_Theme, isFetching } = useStrikeTable();

  if (isFetching)
    return (
      <div
        style={{ marginTop: 100 }}
        className="w-100 justify-content-center d-flex"
      >
        <Spin size="large" />
      </div>
    );

  return (
    <div
      className={`${
        dark_Theme || false
          ? "pricer-ag-grid__container_dark"
          : "pricer-ag-grid__container"
      }`}
      style={{
        width: "100%",
      }}
    >
      <SingleStrikeTable dateTime={dateTime} />
    </div>
  );
}

export default StickyStrikeTable;
